export const notAvailableSrc = 'https://esgiwebfiles.s3.amazonaws.com/images/img-not-available.jpg';
export const rubricThumbnail = 'https://esgiwebfiles.s3.amazonaws.com/images/test-explorer/rubric-thumbnail.png';